module.exports = __webpack_public_path__ + "static/media/LRHS Stationary.243857d5.jpg";